export enum SiteSortField {
  Tier,
  Title,
  Created,
  LastLogin
}
